export default {
      id: "i-arrow-right3-usage",
      viewBox: "0 0 37 37",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-right3",
      toString: function () {
        return this.url;
      }
    }